/**
 * Whether the existing-task popup should treat the task as locked (no edit, reopen,
 * or new comments). Today callers pass only a snapshot date; question-level view-only
 * will also set isQuestionReadOnly.
 */
export function isExistingAdvancedTaskPopupLocked(args: {
  isQuestionReadOnly: boolean;
  snapshotDate: string | Date | null | undefined;
}): boolean {
  return args.isQuestionReadOnly || args.snapshotDate != null;
}

/** Reopen is offered for completed/cancelled tasks only when the popup is not locked. */
export function canReopenExistingAdvancedTask(args: {
  isLocked: boolean;
  isReadOnly: boolean;
  canReOpenThisTask: boolean;
}): boolean {
  return args.isReadOnly && args.canReOpenThisTask && !args.isLocked;
}

/**
 * Matches TaskCommentsPopupTab: comments are blocked when locked, or when the task is
 * both read-only and historic.
 */
export function canAddCommentsToExistingAdvancedTask(args: {
  isLocked: boolean;
  isReadOnly: boolean;
  isHistoric: boolean;
}): boolean {
  return !((args.isReadOnly && args.isHistoric) || args.isLocked);
}
